import templateReplace from 'es6-template-strings';
import { func } from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Typography from 'ravenjs/lib/Typography';
import { get } from 'ravenjs/utils/lodash';
import { stringReplaceWithJSX } from 'ravenjs/utils/string';
import Container from 'ravenjs/lib/Container';
import Link from 'ravenjs/lib/Link';

import MESSAGES from 'constants/messages';
import { HISTORY } from 'constants/proptypes';
import NavLogoImage from 'components/NavLogo/NavLogoImage';
import { actions as brandingActions } from 'modules/branding';
import { actions as uiActions } from 'modules/ui';

const ContainerStyled = styled(Container)`
    position: relative;
    height: 100%;
`;

const HeaderStyled = styled.header`
    min-height: 7.2rem;
    padding: 1.56rem 2.19rem;
    width: 100%;
`;

const InvalidStyled = styled.div`
    padding: 1rem 2.19rem;
    width: 100%;

    ${({ theme }) => theme.media.down('md')`
        padding: 1rem;
    `};
`;

const Invalid = props => {
    const { fetchBranding, history, isLoading } = props;
    const [logoUrl, setLogoUrl] = useState(null);
    const [platformName, setPlatformName] = useState('');
    const getDefaultBranding = useCallback(async () => {
        const domain = MAESTER.companies.root_company_id;
        return fetchBranding(domain);
    }, [fetchBranding]);

    const getBranding = useCallback(async () => {
        let branding;
        try {
            isLoading(true, MESSAGES.LOADING.DEFAULT);
            const subdomain = window.location.host.split('.')[0];
            branding = subdomain ? await fetchBranding(subdomain) : await getDefaultBranding();
        } catch (e) {
            branding = await getDefaultBranding();
        } finally {
            isLoading(false);
        }
        const brandingLogoUrl = get(branding, 'config.logoUrl', null);
        const platformName = get(branding, 'platformName', '');
        setLogoUrl(brandingLogoUrl);
        setPlatformName(platformName);
    }, [fetchBranding, getDefaultBranding, isLoading]);

    const onClickLoginHere = () => {
        history.replace('/auth/login');
    };

    useEffect(() => {
        getBranding();
    }, [getBranding]);

    return (
        <ContainerStyled>
            <HeaderStyled>
                <NavLogoImage alt="Logo" height="35px" width="170px" src={logoUrl} />
            </HeaderStyled>
            <InvalidStyled>
                <Typography fontSize="3rem">{MESSAGES.PUBLIC_CONTENT.INVALID_TITLE}</Typography>
                <Typography fontSize="1.5rem">
                    {stringReplaceWithJSX(
                        templateReplace(MESSAGES.PUBLIC_CONTENT.INVALID_MESSAGE, {
                            platformName,
                        }),
                        {
                            LOGIN_HERE: (
                                <Link
                                    type="link"
                                    fontSize="1.5rem"
                                    onClick={onClickLoginHere}
                                    key="login_here"
                                >
                                    {MESSAGES.PUBLIC_CONTENT.LOGIN_HERE_TEXT}
                                </Link>
                            ),
                        }
                    )}
                </Typography>
            </InvalidStyled>
        </ContainerStyled>
    );
};

Invalid.propTypes = {
    fetchBranding: func.isRequired,
    history: HISTORY.isRequired,
    isLoading: func.isRequired,
};

const mapDispatchToProps = {
    fetchBranding: brandingActions.fetchBranding,
    isLoading: uiActions.isLoading,
};

export { Invalid as InvalidUnwrapped };
export default connect(null, mapDispatchToProps)(Invalid);
